import { render, staticRenderFns } from "./ConsultaAuditGrid.vue?vue&type=template&id=2bb82623&scoped=true&"
import script from "./ConsultaAuditGrid.vue?vue&type=script&lang=js&"
export * from "./ConsultaAuditGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb82623",
  null
  
)

/* custom blocks */
import block0 from "./ConsultaAuditGrid.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports